import { Badge as MantineBadge, BadgeProps as MantineBadgeProps } from '@mantine/core';
import { cva, VariantProps } from 'class-variance-authority';
import { FC } from 'react';

import styles from './Badge.module.css';

const badgeStatusVariants = cva(styles.base, {
    variants: {
        status: {
            neutral: styles.neutral,
            negative: styles.negative,
            prominent: styles.prominent,
            caution: styles.caution,
            info: styles.info,
        },
    },
    defaultVariants: {
        status: 'neutral',
    },
});

const badgeTypeVariants = cva(styles.base, {
    variants: {
        type: {
            number: styles.number,
            dot: styles.dot,
        },
    },
    defaultVariants: {
        type: 'number',
    },
});

export type BadgeProps = MantineBadgeProps &
    VariantProps<typeof badgeStatusVariants> &
    VariantProps<typeof badgeTypeVariants>;

export const Badge: FC<BadgeProps> = ({ children, status, type, ...props }) => {
    const isCircle = type === 'dot';

    return (
        <MantineBadge
            circle={isCircle}
            className={`${badgeStatusVariants({ status })} ${badgeTypeVariants({ type })}`}
            role={isCircle ? undefined : 'status'}
            {...props}
        >
            {type === 'number' && children}
        </MantineBadge>
    );
};
